export default __webpack_public_path__ + "media/images/linkedin-0fe4ead5855c5cc5b890c803a98d6a3d.svg";